export default function genererRecommandation() {
  return {
    pointDeVente: null,
    commentaire: '',
    panneaux: [],
    panneauxSousContrat: [],
    theme: '',
    afficherPanneauxSousContrat: true,
    commercial: null,
    commercialId: null,
    dateCreation: null,
    honoraireForfaitaire: null,
    ligneCommandeHonoraireForfaitaireId: null,
  };
}
